export const POLYGON_MAX_SQ_KM_SIZE = {
  free: 100,
  pro: 4500,
  admin: 12500,
};
